export { default } from './GlobalLoader';
